import React from 'react';
import { Checkbox as RoccoCheckbox } from '@rocco/components/checkbox';
import { Label as RoccoLabel } from '@rocco/components/label';
import type { FilterConfigModalItemDefault } from '@rocco/ui/filter-sort/types/filter-config-modal';
import type { SingleValueFilterState } from '@rocco/ui/filter-sort/view-models/filter-state/single-value-filter-state';
import type { FilterModalElementProps } from '@rocco/ui/filter-sort/components/filters-modal/FiltersModalElement';

export const FiltersModalSingleValue = (
    props: FilterModalElementProps<
        FilterConfigModalItemDefault,
        SingleValueFilterState
    >,
) => {
    const { filterConfigItem, filterState, onFilterStateUpdate } = props;

    return (
        <div className="flex flex-row-reverse items-center justify-between pl-0">
            <RoccoCheckbox
                id={filterConfigItem.filterKey}
                checked={filterState.checked}
                onCheckedChange={checked => {
                    onFilterStateUpdate({ ...filterState, checked: !!checked });
                }}
            />
            <RoccoLabel
                htmlFor={filterConfigItem.filterKey}
                target="checkboxReversed"
            >
                {filterConfigItem.label}
            </RoccoLabel>
        </div>
    );
};
